import "Feature-Blog/js/blog-filter";
import "Feature-Contact/js/contact-department-country-selector";
import "Feature-Contact/js/contact-form-attachments";
import "Feature-Contact/js/contact-section-accordion";
import "Feature-Jobs/js/jobs-filter";
import "Feature-Navigation/js/header-search";
import "Feature-Navigation/js/language-selector";
import "Feature-Navigation/js/mobile-navigation";
import "Feature-PageContent/js/cta-option-selector";
import "Feature-PageContent/js/hero-carousel";
import "Feature-PageContent/js/video-overlay";
import "Feature-Plants/js/certificate-accordion";
import "Feature-Plants/js/certificate-filter";
import "Feature-Plants/js/plant-accordion";
import "Feature-Plants/js/plant-filter";
import "Feature-Plants/js/plant-map";
import "Feature-Search/js/search-module";
import "Feature-Whistleblowing/js/whistleblowing-form-anonimity";
import "Feature-Whistleblowing/js/whistleblowing-form-attachments";

import AOS from "aos";
import Blazy from "blazy";

const bLazy = new Blazy({
  selector: '.js-blazy',
  successClass: 'is-blazy-loaded'
});

AOS.init({
  startEvent: 'load',
  once: true,
  duration: 600,
  offset: 100,
  disable: 'phone'
});

document.addEventListener("DOMContentLoaded", function () {
  $('.slider').slick({
    dots: true,
    arrows: true
  });
});